<template>
  <v-dialog scrollable max-width="1200px" v-model="showDialog">
    <template v-slot:activator="{ on }">
      <div class="my-2">
        <v-btn v-on="on">Migracion de Pagos Gestion</v-btn>
      </div>
    </template>
    <v-card>
      <v-card-title> Migracion de pagos gestion </v-card-title>
      <v-card-text>
        <v-form ref="form">
          <v-text-field
            type="text"
            label="Id Socio"
            v-model="idSocio"
            autofocus
            :disabled="lista.length > 0"
          />
          <v-text-field type="text" label="Cod Mem SQ" v-model="codMemSq" :disabled="nombreSocioSGS != '' " />
          {{ nombreSocioSGS }}
          <v-text-field type="text" label="Importe" v-model="importe" />
        </v-form>

        <v-btn
          color="warning"
          v-if="habilitado"
          :loading="loading"
          @click.once="procesar"
          >PROCESAR</v-btn
        >
        <h3 class="red--text">{{ errorMessage }}</h3>
        <v-data-table
          dense
          v-model="selectedRows"
          show-select
          single-select
          item-key="codPeriodo"
          :headers="headers"
          hide-default-footer
          :items-per-page="-1"
          :items="lista"
          class="elevation-1"
        >
        </v-data-table>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <v-btn color="info" @click="volver">Volver</v-btn>
        <v-btn color="info" @click="buscar">BUSCAR</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import axios from "axios";

export default {
  data() {
    return {
      idSocio: null,
      showDialog: false,
      importe: null,
      codMemSq: null,
      nombreSocioSGS: '',
      errorMessage: '',
      lista: [],
      selectedRows: [],
      headers: [
        { text: "IdSocio", value: "idSocio" },
        { text: "Cedula", value: "cedula" },
        // { text: "Id Titular", value: "titular.id" },
        // { text: "Tipo", align: "start", value: "titular.memType" },
        { text: "Nombres", value: "nombres" },
        { text: "CodPeriodo", value: "codPeriodo" },
        { text: "Periodo", value: "periodo" },
        { text: "Importe", value: "importe", align: "right" },
      ],
    };
  },
  computed: {
    habilitado() {
      return this.selectedRows.length == 1 && this.nombreSocioSGS.length > 1;
    }
  },
  watch: {
    selectedRows() {
      if (this.selectedRows.length > 0) {
        this.importe = this.selectedRows[0].importe;
      } else {
        this.importe = null;
      }
    },
  },
  methods: {
    volver() {
      this.showDialog = false;
      this.lista = [];
      this.nombreSocioSGS = '';
      this.codMemSq = null;
      this.idSocio = null;
      this.errorMessage = '';
    },
    procesar() {
      console.log(this.idSocio);

      this.errorMessage = '';
      this.loading = true;

      let params = {
        idSocio: this.selectedRows[0].idSocio,
        codPeriodo: this.selectedRows[0].codPeriodo,
        codMemSq: this.codMemSq,
        monto: this.importe
      }

      axios
        .post("/pago/gestion/migrarPago", null, { params: params})
        .then((res) => {
          console.log(res);
          alert('migracion procesada!');
          this.loading = false;
          this.volver();
        })
        .catch((err) => {
          this.message = "";
          this.loading = false;
          console.log(err);
          if (err.response.data) {
            this.errorMessage = err.response.data;
          } else {
            this.errorMessage = "Error";
          }
          return;
        });
      
    },
    async buscar() {
      if (isNaN(this.idSocio)) return;
      if (isNaN(this.codMemSq)) return;

      this.nombreSocioSGS = null

      await axios
        .get("/persona/buscar?valor=" + this.codMemSq + "&propiedad=codigoSGS")
        .then((res) => {
          console.log(res);
          if (res.data.length > 0) {
            this.nombreSocioSGS = res.data[0].codMemSq + " " + res.data[0].nombreCompleto;
          } 
        })
        .catch((err) => {
          this.message = "";
          this.loading = false;
          console.log(err);
          if (err.response.data) {
            this.errorMessage = err.response.data;
          } else {
            this.errorMessage = "Error";
          }
          return;
        });

      await axios
        .get("/pago/gestion/pendientes/" + this.idSocio)
        .then((res) => {
          console.log(res);
          this.lista = res.data;
        })
        .catch((err) => {
          this.message = "";
          this.loading = false;
          console.log(err);
          if (err.response.data) {
            this.errorMessage = err.response.data;
          } else {
            this.errorMessage = "Error";
          }
        });
    },
  },
};
</script>